const materialRouter = [
    // 主页
    {
      path: '/material',
      name: 'material',
      component: () => import('@/views/material/index.vue')
    }, // 企业码
    {
      path: '/materialDetail',
      name: 'materialDetail',
      component: () => import('@/views/material/materialDetail.vue')
    },
  ]
  export default materialRouter